"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Draggable = /*#__PURE__*/function () {
  function Draggable(el) {
    _classCallCheck(this, Draggable);
    this.el = el;
    this.el.style.pointerEvents = 'none';
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.el.addEventListener('mousedown', this.handleMouseDown);
    this.handleWindowMouseMove = this.handleWindowMouseMove.bind(this);
    this.handleWindowMouseUp = this.handleWindowMouseUp.bind(this);
    this.resetCssText = "position: fixed; top: 0; left: 0; z-index: 1050; pointerEvents: auto;";
    this.fadeDelay = 700;
  }
  _createClass(Draggable, [{
    key: "handleWindowMouseMove",
    value: function handleWindowMouseMove(evt) {
      this.Sx = evt.clientX - this.x + this.Ox;
      this.Sy = evt.clientY - this.y + this.Oy;
      this.el.style.top = this.Sy + "px";
      this.el.style.left = this.Sx + "px";
    }
  }, {
    key: "handleWindowMouseUp",
    value: function handleWindowMouseUp() {
      window.removeEventListener('mousemove', this.handleWindowMouseMove);
      window.removeEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(evt) {
      this.x = evt.clientX;
      this.y = evt.clientY;
      this.Ox = this.el.offsetLeft;
      this.Oy = this.el.offsetTop;
      window.addEventListener('mousemove', this.handleWindowMouseMove);
      window.addEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;
      setTimeout(function () {
        _this.el.style.cssText = _this.resetCssText;
      }, this.fadeDelay);
      this.el.removeEventListener('mousedown', this.handleMouseDown);
    }
  }]);
  return Draggable;
}();
exports.default = Draggable;